import api from '@pray/shared/utils/api';

import type { BrandKitFields, BrandKitResponse } from './types';

const trimmedOrNull = (value: string | null | undefined) => value?.trim() || null;

export async function saveBrandKit({
  artistId,
  brandKit,
}: {
  artistId: string;
  brandKit: BrandKitFields;
}): Promise<BrandKitResponse> {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/brand-kit`;
  const response = await api.executePutRequest(url, {
    logo_url: trimmedOrNull(brandKit.logo_url),
    primary_color: trimmedOrNull(brandKit.primary_color),
    secondary_color: trimmedOrNull(brandKit.secondary_color),
    caption_color: trimmedOrNull(brandKit.caption_color),
    highlight_color: trimmedOrNull(brandKit.highlight_color),
    headline_font_name: trimmedOrNull(brandKit.headline_font_name),
    headline_font_url: trimmedOrNull(brandKit.headline_font_url),
    caption_font_name: trimmedOrNull(brandKit.caption_font_name),
    caption_font_url: trimmedOrNull(brandKit.caption_font_url),
    intro_url: trimmedOrNull(brandKit.intro_url),
    outro_url: trimmedOrNull(brandKit.outro_url),
    aspect_ratios: brandKit.aspect_ratios,
    notes: trimmedOrNull(brandKit.notes),
  });

  return response.data.data;
}
